import { MODELS } from './settings';
import { get, capitalize } from 'lodash';

const TEXTS = {
    [MODELS.PERMISSION]: {
        functionsTablePrefix: {
            [MODELS.PARTNER]: 'Media Partner',
            [MODELS.ORGANIZATION]: 'Organization',
            [MODELS.ARTIST]: 'Artist'
        }
    },
    [MODELS.ARTIST_CONTACTS]: {
        tableButtonLabel: 'Add Artist Contact'
    },
    [MODELS.EVENT_EMAIL_SENDER]: {
        tableButtonLabel: 'Add Event Email Sender',
        tableLoadingText: 'Loading event email senders...',
        tableDeletingText: 'Removing event email sender(s)...'
    },
    [MODELS.CONTRACT_PARTNER]: {
        tableButtonLabel: 'Add Partner',
        tableLoadingText: 'Loading partners...',
        tableDeletingText: 'Removing partner(s) from contract...',
        tableConfirmDelete: 'Are you sure you want to remove this partner from the contract?'
    },
    [MODELS.EVENT_PARTNER]: {
        tableConfirmDelete: `Are you sure you want to remove the partner from the event?`,
        tableButtonLabel: 'Add Partner',
        tableLoadingText: 'Loading partners...',
        tableDeletingText: `Removing partner(s) from event...`
    },
    [MODELS.EVENT_ARTIST]: {
        tableConfirmDelete: `Are you sure you want to remove the artist from the event?`,
        tableButtonLabel: 'Add Artist',
        tableLoadingText: 'Loading artists...',
        tableDeletingText: `Removing artist(s) from event...`
    },
    [MODELS.EVENT_EMAIL]: {
        tableLoadingText: 'Loading emails...'
    },
    [MODELS.EVENT_REMINDER]: {
        tableConfirmDelete: `Are you sure you want to delete this automatic reminder?`,
        tableLoadingText: 'Loading automatic reminders...',
        // tableLoadingText: `Loading reminders...`,
        tableButtonLabel: `Add reminder`,
        tableConfirmDeleteMultiple: `Are you sure you want to delete these automatic reminders?`,
        tableDeletingText: `Deleting reminder(s)...`,
        tableDeleteText: `Reminder(s) successfully deleted.`
    },
    [MODELS.EVENT_CLEARANCE_CONFIG]: {
        tableConfirmDelete: `Are you sure you want to delete this category? The category will be removed in all performances of your event.`,
        tableLoadingText: 'Loading categories...',
        tableButtonLabel: `ADD CATEGORY`,
        tableConfirmDeleteMultiple: `Are you sure you want to delete these categories?`,
        tableDeletingText: `Deleting category(ies)...`,
        tableDeleteText: `Category(ies) successfully deleted.`
    },
    [MODELS.EVENT_CLEARANCE_CATEGORY]: {
        tableConfirmDelete: `Are you sure you want to delete this category? The category will be removed in all performances of your event.`,
        tableLoadingText: 'Loading categories...',
        tableButtonLabel: `ADD CATEGORY`,
        tableConfirmDeleteMultiple: `Are you sure you want to delete these categories?`,
        tableDeletingText: `Deleting category(ies)...`,
        tableDeleteText: `Category(ies) successfully deleted.`
    },
    [MODELS.EVENT_CLEARANCE_LABEL]: {
        tableButtonLabel: `ADD LABEL`,
        tableLoadingText: 'Loading labels...',
        tableDeletingText: 'Removing label(s)...',
        tableDeleteText: 'Label(s) successfully deleted.',
        tableConfirmDelete: 'Are you sure you want to delete this label?',
        tableConfirmDeleteMultiple: 'Are you sure you want to delete these labels?'
    },
    [MODELS.IMPORT]: {
        tableLoadingText: 'Loading imports...',
        tableButtonLabel: 'Select CSV',
        statuses: {
            failed: 'Import failed',
            success: 'Import successfully',
            progress: 'In progress'
        }
    },
    [MODELS.CONTRACT]: {
        detailsEdit: 'Send',
        detailsSave: 'Send',
        tableDeletingText: 'Work in progress...'
    },
    [MODELS.DEFAULT]: {
        tableConfirmDelete: (model) => `Are you sure you want to delete this ${model}?`,
        tableConfirmDeleteMultiple: (model) => `Are you sure you want to delete these ${model}s?`,
        tableDeletingText: (model) => `Deleting ${model}(s)...`,
        tableLoadingText: (model) => `Loading ${model}s...`,
        tableDeleteText: (model) => `${capitalize(model)}(s) successfully deleted.`,
        tableButtonLabel: (model) => `Add ${model}`,
        detailsEdit: () => 'Edit',
        detailsSave: () => 'Save'
    }
};

export const getText = (model, path) =>
    get(TEXTS, `${model}.${path}`) || (TEXTS[MODELS.DEFAULT][path] ? TEXTS[MODELS.DEFAULT][path](model) : '');
